module.exports = __webpack_public_path__ + "static/media/trombone.6721ee46.wav";